/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import { Formik, FormikProps } from 'formik'
import { correctEmailFormat } from '@src/utils/accounts'
import { getAccountInfoConfig, AccountInfoValues } from './configurations'
import type { StepProps } from '../models'
import {
  AccountInfoForm,
  AccountInfoFormActions
} from './components/form.account.information'
import { useState } from 'react'

export interface AccountInfoState {
  showOldPassword: boolean
  showNewPassword: boolean
}

export const UserInformation = (stepProps: StepProps) => {
  const [showOldPassword, setShowOldPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)

  function toggleOldPassword() {
    setShowOldPassword(!showOldPassword)
  }

  function toggleNewPassword() {
    setShowNewPassword(!showNewPassword)
  }

  function changePassword(oldPassword: string, newPassword: string) {
    if (!oldPassword || !newPassword) return false
  }

  const { tenant = {}, user = {} } = stepProps
  const initialValues = {
    firstName:
      user?.first_name !== 'none' && !!user?.first_name ? user?.first_name : '',
    lastName:
      user?.last_name !== 'none' && !!user?.last_name ? user?.last_name : '',
    email: correctEmailFormat(user?.email),
    oldPassword: '',
    newPassword: '',
    location: tenant?.address || '', // user.location || '',
    jobTitle: user?.role !== 'none' && !!user?.role ? user?.role : ''
  }

  const actions: AccountInfoFormActions = {
    toggleOldPassword,
    toggleNewPassword,
    changePassword
  }

  const state = {
    showOldPassword,
    showNewPassword
  }

  return (
    <Formik
      {...getAccountInfoConfig({
        initialValues,
        stepProps,
        state,
        actions
      })}
    >
      {(props: FormikProps<AccountInfoValues>) => (
        <AccountInfoForm
          formikProps={props}
          state={state}
          stepProps={stepProps}
          actions={actions}
        />
      )}
    </Formik>
  )
}
